<!--
  DetailHeader.vue
  콜봇 월 정산 · 병원 상세의 공통 헤더(모든 탭에서 같은 자리) — 화면 명세 2 "공통 헤더"를 목업 Detail.dc.html 모양으로.

  위에서부터
  - 길잡이: 브레드크럼 `콜봇 관리 › 월 정산 › <병원>`(월 정산은 목록 링크)과 `← 병원 목록`. 둘 다 같은 달 +
    목록이 sessionStorage 'admin.settlementListQuery' 에 둔 구분·검색·정렬의 목록으로 돌아간다
    (읽기는 settlementListQuery.readSavedListQuery).
  - 병원 이름 + 마감 상태 알약 하나(추정 중 회색 · 마감 중 파랑 · 검토 필요 주황 · 확정 초록 · 마감 실패 빨강, 툴팁은
    detailStatusBadge — 정산 대상 아닌 달은 회색 '정산 대상 아님') + 경고가 있으면 작은 '경고 n건'(차단 빨강 · 비차단만 회색, 툴팁에 목록, 누르면 정산 탭 focus-warnings —
    showWarnings: 정산 탭에서는 패널이 목록을 보여 셸이 끈다) + 확정이면 [재수정](showReopen — 정산 탭에서는 곁 카드에 있어
    셸이 끈다). 오른쪽에 월 선택(고르면 'change-month' 만 보낸다).
  - 칩: 구분 · 요율(`기본 요율 <버전>` / `예외 n칸` / `v70 이전 요율` / `기본 요율 없음`·`기본 요율 v70 이전`, 툴팁에 적용 버전과
    덮은 칸, 보조 "미정 회선 n개") · 상담사 연결(그 달 실제 통화 기준, 목록과 같은 표기).
  - 정산 요약 카드: 큰 '청구 합계'(부가세 포함, 추정치면 '· 추정') + 공급가액 · 부가세 · vox 원가 · 마진(%). 작은 알약
    `일부 제외` · `v70 이전 금액` · 재수정 중이면 `직전 확정 n원`. `—` 규칙은 settlementRules.summaryLine 이 정한다 — 요금표 v70
    이전에 만든 정산서(`statement.legacy`)는 그때 저장한 합계와 부가세를 보이고 마진은 '—'다. 금액 칸의 툴팁은 키보드
    포커스로도 열린다(tabindex 0).
  - 목이 켜지면 길잡이 줄 오른쪽 접힌 'DEV 목 조작' 안에 마감 상태 고르기, `목: 미종료 통화 끝내기`·`목: 늦게 들어온 통화 2건`,
    `목: 다음 쓰기 409 충돌`, `수납 상태` 고르기, `목: 다음 재수정 503`, 정산 시작일 넣기(텍스트 + [적용]/[지우기] — 규칙 검사 없이
    바로 바꾼다), `시작일 PUT 오류` 고르기, `목: 웹 일별 칸 없음`. 고르거나 누르면 목을 바꾸고 'mock-change' 를 보낸다
    (셸이 다시 받는다). 사용량 버튼은 바꿀 것이 없으면 알리기만 한다.
  - 정산 시작일(~/md/plan/콜봇-월정산-정산시작일-엑셀내보내기-계획.md 4-3): 칩 줄 끝에 시작일 칩(settlementScopeView — 미설정 ·
    정산 대상 · 시작 월 · 정산 대상 아님, 툴팁은 이 달에 적용되는 규칙 한 문장). canEditStart 면 칩이 버튼이 되어 'open-start' 를
    보낸다. 얼린 시작일 ≠ 지금 값이면 옆에 '다시 계산 필요'. 정산 대상 아닌 달(before_start)은 알약이 회색 '정산 대상 아님',
    요약 카드의 청구 합계·공급가액·부가세 자리가 '청구 없음', 마진 '—'(vox 원가는 보인다). 시작 월(1일 아님)이면 vox 원가는
    청구분(cost.billable)이고 그 뒤에 '시작 전 원가' 칸을 더한다. 새 칸이 없는 응답은 칩 '시작일 미설정'에 지금 화면 그대로다.
  - 월 선택 옆 [엑셀 내보내기](canExport) → 'open-export'(셸이 회사 1곳으로 내보내기 모달을 연다).

  - props: companyId · month('YYYY-MM') · companyName(null 이면 아직 모름 — 자리표시) · detail(상세 응답, 없으면 null) ·
    loading · mock · showReopen · showWarnings · canExport · canEditStart(둘 다 기본 true — 5단계 권한 숨김 자리)
  - emits: change-month(month) · go-tab(tab, intent) · open-reopen() · mock-change() · open-start() · open-export()
  - detail 이 아직 없으면(첫 로드) 칩·요약 자리에 스켈레톤을 보이고, 불러오지 못했으면 길잡이·이름·월 선택만 보인다.
  요청 문서: ~/md/front/admin-콜봇-월정산-프론트요청.md "화면 명세 2 공통 헤더", "요청 계약 2"
-->
<template>
  <header class="detail-head">
    <!-- 길잡이 -->
    <div class="detail-head__nav">
      <nav class="detail-head__crumbs" aria-label="현재 위치">
        <span>콜봇 관리</span>
        <span class="detail-head__sep" aria-hidden="true">›</span>
        <router-link class="detail-head__crumb-link" :to="listLocation">월 정산</router-link>
        <template v-if="companyName">
          <span class="detail-head__sep" aria-hidden="true">›</span>
          <span class="detail-head__crumb-current" aria-current="page">{{ companyName }}</span>
        </template>
      </nav>
      <router-link class="detail-head__back" :to="listLocation">← 병원 목록</router-link>

      <!-- 개발용 목 조작 — 한 곳에 접어 둔다 -->
      <details v-if="mock" class="detail-head__dev">
        <summary class="detail-head__dev-summary">
          <SettlementMockBadge />
          <span>DEV 목 조작</span>
        </summary>
        <div class="detail-head__dev-body" role="group" aria-label="목 데이터 조작(개발용)">
          <label class="detail-head__dev-field">
            <span>마감 상태</span>
            <a-select
              class="detail-head__mock-select"
              size="small"
              :value="mockStatus"
              :options="mockStatusOptions"
              aria-label="목 마감 상태"
              @change="onMockStatus"
            />
          </label>
          <a-tooltip>
            <template #title>
              <div v-for="(line, i) in MOCK_FINISH_TOOLTIP_LINES" :key="i">{{ line }}</div>
            </template>
            <a-button size="small" @click="onMockFinishOpenCalls">목: 미종료 통화 끝내기</a-button>
          </a-tooltip>
          <a-tooltip>
            <template #title>
              <div v-for="(line, i) in MOCK_LATE_TOOLTIP_LINES" :key="i">{{ line }}</div>
            </template>
            <a-button size="small" @click="onMockAddLateCalls">목: 늦게 들어온 통화 {{ MOCK_LATE_CALLS }}건</a-button>
          </a-tooltip>
          <a-tooltip :title="MOCK_CONFLICT_TOOLTIP">
            <a-checkbox :checked="mockConflict" @update:checked="onMockConflict">목: 다음 쓰기 409 충돌</a-checkbox>
          </a-tooltip>
          <label class="detail-head__dev-field">
            <span>수납 상태</span>
            <a-select
              class="detail-head__mock-select"
              size="small"
              :value="mockPayment"
              :options="mockPaymentOptions"
              :dropdown-match-select-width="false"
              aria-label="목 수납 상태"
              @change="onMockPayment"
            />
          </label>
          <a-tooltip :title="MOCK_STOP_FAIL_TOOLTIP">
            <a-checkbox :checked="mockStopFail" @update:checked="onMockStopFail">목: 다음 재수정 503</a-checkbox>
          </a-tooltip>
          <span class="detail-head__dev-field">
            <a-tooltip :title="MOCK_START_TOOLTIP">
              <span>시작일</span>
            </a-tooltip>
            <a-input
              v-model:value="mockStartInput"
              class="detail-head__mock-date"
              size="small"
              placeholder="YYYY-MM-DD"
              aria-label="목 정산 시작일"
              @press-enter="onMockStartApply"
            />
            <a-button size="small" @click="onMockStartApply">적용</a-button>
            <a-button size="small" @click="onMockStartClear">지우기</a-button>
          </span>
          <label class="detail-head__dev-field">
            <span>시작일 PUT 오류</span>
            <a-select
              class="detail-head__mock-select"
              size="small"
              :value="mockStartFault"
              :options="mockStartFaultOptions"
              :dropdown-match-select-width="false"
              aria-label="목 시작일 PUT 오류"
              @change="onMockStartFault"
            />
          </label>
          <a-tooltip :title="MOCK_WEB_SPLIT_TOOLTIP">
            <a-checkbox :checked="mockWebSplitMissing" @update:checked="onMockWebSplitMissing">목: 웹 일별 칸 없음</a-checkbox>
          </a-tooltip>
        </div>
      </details>
    </div>

    <!-- 병원 이름 + 마감 상태 + 칩 / 월 선택 -->
    <div class="detail-head__top">
      <div class="detail-head__ident">
        <div class="detail-head__name-row">
          <h1 class="detail-head__name">
            <template v-if="companyName">{{ companyName }}</template>
            <template v-else>
              <a-skeleton-input class="detail-head__name-skeleton" active size="small" />
              <span class="detail-head__sr">병원 이름 불러오는 중</span>
            </template>
            <span class="detail-head__sr"> · {{ monthText }} 정산</span>
          </h1>
          <a-tooltip v-if="detail" :title="statusBadge.tooltip">
            <span class="detail-head__status" :class="`is-${statusBadge.status}`">{{ statusLabel }}</span>
          </a-tooltip>
          <!-- Warnings stay visible on the other tabs (the settle tab shows the list itself) -->
          <a-tooltip v-if="detail && showWarnings && summary.warnings.total > 0">
            <template #title>
              <div v-for="(line, i) in warningTooltipLines" :key="i">{{ line }}</div>
            </template>
            <button
              type="button"
              class="detail-head__warn"
              :class="`is-${summary.warnings.tone}`"
              :aria-label="`${summary.warnings.label} — 정산 탭에서 보기`"
              @click="goWarnings"
            >
              {{ summary.warnings.label }}
            </button>
          </a-tooltip>
          <a-button v-if="canReopen && showReopen" size="small" class="detail-head__reopen" @click="emit('open-reopen')">
            <i class="fa-solid fa-rotate-left" aria-hidden="true"></i>
            재수정
          </a-button>
          <span v-if="refreshing" class="detail-head__refreshing" role="status">
            <a-spin size="small" />
            불러오는 중
          </span>
        </div>

        <div v-if="detail" class="detail-head__chips">
          <a-tooltip :title="categoryTooltip">
            <span class="head-chip">{{ categoryText }}</span>
          </a-tooltip>

          <a-tooltip>
            <template #title>
              <div v-for="(line, i) in rateTooltipLines" :key="i">{{ line }}</div>
            </template>
            <span class="head-chip" :class="`is-${rateChip.tone}`">
              {{ rateChip.label }}
              <span v-if="rate.missingLabel" class="head-chip__sub is-warn">{{ rate.missingLabel }}</span>
            </span>
          </a-tooltip>

          <a-tooltip>
            <template #title>
              <div v-for="(line, i) in connect.tooltipLines" :key="i">{{ line }}</div>
            </template>
            <span class="head-chip">
              상담사 연결 {{ connect.label }}
              <span v-if="connect.sub" class="head-chip__sub">{{ connect.sub }}</span>
            </span>
          </a-tooltip>

          <!-- 정산 시작일 — 고칠 수 있으면 버튼(시작일 모달) -->
          <a-tooltip :title="startChipTooltip">
            <button
              v-if="canEditStart"
              type="button"
              class="head-chip head-chip--start is-button"
              :class="`is-${scope.kind}`"
              :aria-label="`${scope.chip.text} — 정산 시작일 바꾸기`"
              @click="emit('open-start')"
            >
              <CalendarOutlined aria-hidden="true" />
              {{ scope.chip.text }}
            </button>
            <span v-else class="head-chip head-chip--start" :class="`is-${scope.kind}`">
              <CalendarOutlined aria-hidden="true" />
              {{ scope.chip.text }}
            </span>
          </a-tooltip>
          <a-tooltip v-if="scope.needsRecalc" :title="NEEDS_RECALC_TOOLTIP">
            <span class="head-chip is-warn">{{ NEEDS_RECALC_TEXT }}</span>
          </a-tooltip>
        </div>
        <a-skeleton-input v-else-if="loading" class="detail-head__chips-skeleton" active size="small" />
      </div>

      <div class="detail-head__tools">
        <SettlementMonthPicker :value="month" @change="onMonthChange" />
        <a-button v-if="canExport && detail" class="detail-head__export" @click="emit('open-export')">
          <DownloadOutlined aria-hidden="true" />
          엑셀 내보내기
        </a-button>
      </div>
    </div>

    <!-- 첫 로드 -->
    <a-skeleton
      v-if="!detail && loading"
      class="detail-head__skeleton"
      active
      :title="false"
      :paragraph="{ rows: 2, width: ['40%', '100%'] }"
    />

    <!-- 정산 요약 카드 -->
    <div v-else-if="detail" class="sum-card" role="group" aria-label="정산 요약">
      <div class="sum-card__main">
        <span class="sum-card__label">
          청구 합계
          <span class="sum-card__dim">(부가세 포함{{ sourceWord ? ` · ${sourceWord}` : '' }})</span>
        </span>
        <a-tooltip :title="totalTooltip" :trigger="TIP_TRIGGER">
          <span class="sum-card__big" tabindex="0">
            <template v-if="notBillable">{{ notBillableText }}</template>
            <template v-else-if="isNumber(summary.totalWithVat)">
              {{ formatNumber(summary.totalWithVat) }}<small>원</small>
            </template>
            <template v-else>{{ EMPTY }}</template>
          </span>
        </a-tooltip>
        <span v-if="hasPills" class="sum-card__pills">
          <a-tooltip v-if="summary.supply.partial">
            <template #title>
              <div>판매가 미정으로 금액에서 뺀 항목</div>
              <div v-for="(line, i) in summary.supply.partialLines" :key="i">· {{ line }}</div>
            </template>
            <span class="sum-card__pill is-warn">일부 제외</span>
          </a-tooltip>
          <a-tooltip v-if="summary.supply.legacy" :title="LEGACY_STATEMENT_TEXT">
            <span class="sum-card__pill is-warn">v70 이전 금액</span>
          </a-tooltip>
          <a-tooltip v-if="summary.supply.lastConfirmed" :title="lastConfirmedTooltip">
            <span class="sum-card__pill">{{ summary.supply.lastConfirmed.label }}</span>
          </a-tooltip>
        </span>
      </div>

      <dl class="sum-card__grid" :class="{ 'has-pre-start': hasPreStart }">
        <div class="sum-card__cell">
          <dt>공급가액</dt>
          <a-tooltip :trigger="TIP_TRIGGER">
            <template #title>
              <div v-for="(line, i) in supplyTooltipLines" :key="i">{{ line }}</div>
            </template>
            <dd tabindex="0">{{ notBillable ? notBillableText : formatWon(summary.supply.amount) }}</dd>
          </a-tooltip>
        </div>
        <div class="sum-card__cell">
          <dt>부가세</dt>
          <a-tooltip :title="vatTooltip" :trigger="TIP_TRIGGER">
            <dd tabindex="0">{{ notBillable ? notBillableText : formatWon(summary.vat) }}</dd>
          </a-tooltip>
        </div>
        <div class="sum-card__cell">
          <dt>vox 원가</dt>
          <a-tooltip :trigger="TIP_TRIGGER">
            <template #title>
              <div v-for="(line, i) in costTooltipLines" :key="i">{{ line }}</div>
            </template>
            <dd tabindex="0">{{ formatWon(summary.cost.total) }}</dd>
          </a-tooltip>
        </div>
        <div v-if="hasPreStart" class="sum-card__cell">
          <dt>시작 전 원가</dt>
          <a-tooltip :trigger="TIP_TRIGGER">
            <template #title>
              <div v-for="(line, i) in preStartTooltipLines" :key="i">{{ line }}</div>
            </template>
            <dd tabindex="0">{{ formatWon(summary.cost.preStart) }}</dd>
          </a-tooltip>
        </div>
        <div class="sum-card__cell">
          <dt>마진</dt>
          <a-tooltip :trigger="TIP_TRIGGER">
            <template #title>
              <div v-for="(line, i) in marginTooltipLines" :key="i">{{ line }}</div>
            </template>
            <dd tabindex="0" :class="{ 'is-ok': isNumber(summary.margin) && summary.margin >= 0, 'is-negative': summary.margin < 0 }">
              {{ formatWon(summary.margin) }}
              <span v-if="marginRate !== null" class="sum-card__rate">{{ marginRate }}%</span>
            </dd>
          </a-tooltip>
        </div>
      </dl>
    </div>
  </header>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { message } from 'ant-design-vue';
import { CalendarOutlined, DownloadOutlined } from '@ant-design/icons-vue';

import SettlementMockBadge from './SettlementMockBadge.vue';
import SettlementMonthPicker from './SettlementMonthPicker.vue';
import { EMPTY, formatCount, formatKstDateTime, formatNumber, formatWon, isNumber, monthLabel } from '../service/settlementFormat';
import { readSavedListQuery } from '../service/settlementListQuery';
import {
  LEGACY_STATEMENT_TEXT,
  STATEMENT_STATUS_META,
  VAT_LABEL,
  actorLabel,
  categoryLabel,
  connectModeCell,
  counselorItemLabel,
  detailConnectMode,
  detailStatusBadge,
  isInternalDetail,
  legacyPlanVersionOf,
  legacyStatementActionText,
  oneOffAmountOf,
  rateBadge,
  settlementListLocation,
  statementStatusOf,
  summaryLine,
} from '../service/settlementRules';
import { NEEDS_RECALC_TEXT, NEEDS_RECALC_TOOLTIP, settlementScopeView } from '../service/settlementStart';
import { settlementMockControls } from '../service/settlementMock';

const props = defineProps({
  companyId: { type: String, required: true },
  /** 'YYYY-MM'(KST) */
  month: { type: String, required: true },
  /** 제목·브레드크럼의 병원 이름. null 이면 아직 모른다(첫 로드 중 — 자리표시) */
  companyName: { type: String, default: null },
  /** 정산 상세 응답(요청 계약 2). 아직 없으면 null */
  detail: { type: Object, default: null },
  loading: { type: Boolean, default: false },
  /** ?settlementMock=1 — 목 배지와 마감 상태 고르기·사용량 버튼 */
  mock: { type: Boolean, default: false },
  /** Show [재수정] next to the status pill — the shell turns it off on the settle tab (its aside card has it) */
  showReopen: { type: Boolean, default: true },
  /** Show the small '경고 n건' link — the shell turns it off on the settle tab (its state panel lists them) */
  showWarnings: { type: Boolean, default: false },
  /** [엑셀 내보내기] 버튼 — 5단계에서 권한 숨김(canByMode)이 꽂힌다 */
  canExport: { type: Boolean, default: true },
  /** 시작일 칩을 버튼으로(시작일 모달) — 5단계에서 권한 숨김이 꽂힌다 */
  canEditStart: { type: Boolean, default: true },
});

const emit = defineEmits(['change-month', 'go-tab', 'open-reopen', 'mock-change', 'open-start', 'open-export']);

/** 기본 요율 없이 사람이 넣은 금액만 있는 정산(회신 표 16) — 계산값이 없어 마진도 없다 */
const MANUAL_ONLY_TEXT =
  '그 달에 적용할 기본 요율 버전이 없어 계산값은 없고, 사람이 넣은 금액(항목 금액·일회성 항목)만 합했습니다. 마진은 계산하지 않습니다.';

/**
 * Source word after 청구 합계 — response `charge.source`. Only the live estimate gets one ('추정', the state panel's word);
 * review / confirmed would repeat the status pill next to the hospital name
 */
const SOURCE_WORDS = { estimate: '추정' };
/** Source explanation — appended to the total tooltip */
const SOURCE_TOOLTIPS = {
  confirmed: '확정 스냅샷의 금액입니다.',
  review: '검토 필요 스냅샷의 금액입니다. 사람이 넣은 금액을 포함할 수 있습니다.',
  estimate: '마감 전 추정치입니다. 지금 사용량과 이 달 요율로 계산했습니다.',
};

/** Amount tooltips also open on keyboard focus (the values carry tabindex 0) */
const TIP_TRIGGER = ['hover', 'focus'];

const arr = (v) => (Array.isArray(v) ? v : []);

// ---------------------------------------------------------------------------
// 길잡이·제목
// ---------------------------------------------------------------------------

// 목록이 남긴 구분·검색·정렬(sessionStorage). 막혀 있으면 같은 달 기본 목록으로
const listLocation = computed(() => settlementListLocation(props.month, readSavedListQuery()));
const monthText = computed(() => monthLabel(props.month));
// 같은 병원·월을 다시 받는 중(쓰기 뒤 등) — 화면은 그대로 두고 작은 표시만
const refreshing = computed(() => props.loading && !!props.detail);

function onMonthChange(month) {
  emit('change-month', month);
}

// ---------------------------------------------------------------------------
// 칩 · 마감 상태
// ---------------------------------------------------------------------------

const internal = computed(() => isInternalDetail(props.detail));
const categoryText = computed(() => categoryLabel(internal.value ? 'internal' : props.detail?.category ?? 'hospital'));
const categoryTooltip = computed(() =>
  internal.value
    ? '그 달 요율의 구분이 내부·테스트입니다. 청구는 0원이고 마진은 계산하지 않습니다.'
    : '그 달 요율의 구분 칸으로 정합니다.'
);

const rate = computed(() => rateBadge(props.detail));
const rateTooltipLines = computed(() => {
  const lines = [rate.value.tooltip];
  if (rate.value.missingCount > 0) {
    lines.push(`판매가가 미정인 회선 ${formatNumber(rate.value.missingCount)}개 — 그 회선 금액은 빠졌습니다`);
  }
  lines.push('칸별 요율은 요율 탭에서 봅니다.');
  return lines;
});

/**
 * 상담사 연결 방식 — 그 달 실제 통화 기준. 보조 표기("vox 직접 n / 요청 m")는 목록과 같다. 상세의 `connect_mode` 는
 * 목록과 같은 `{ mode, pbx, vox_direct }` 객체다(회신 표 4) — vox 직접 응답 수가 없으면(예전 모양) leg 에서 센다.
 */
const connect = computed(() => {
  const counselor = props.detail?.usage?.counselor;
  const legs = arr(counselor?.legs);
  const mode = detailConnectMode(props.detail);
  const voxDirect =
    mode.vox_direct ??
    legs
      .filter((leg) => leg?.route === 'vox_direct')
      .reduce((sum, leg) => sum + (isNumber(leg?.answered) ? leg.answered : 0), 0);
  const cell = connectModeCell({
    connect_mode: { mode: mode.mode, vox_direct: voxDirect },
    handoffs: counselor?.requested,
  });
  const tooltipLines = ['그 달 실제 통화 기준입니다(에이전트 설정값이 아닙니다).'];
  if (legs.length) {
    legs.forEach((leg) => tooltipLines.push(`${counselorItemLabel(leg)} 응답 ${formatCount(leg?.answered, '통')}`));
  } else {
    tooltipLines.push('이 달 상담사가 받은 통화가 없습니다.');
  }
  return { label: cell.label, sub: cell.sub, tooltipLines };
});

/**
 * Rate chip — the mockup's "기본 요율 2026-09". 예외 keeps "예외 n칸"; an internal company shows its version (the category chip
 * already says 내부·테스트). Legacy / missing default rate keep the rateBadge label.
 */
const rateChip = computed(() => {
  const r = rate.value;
  const rates = props.detail?.rates ?? null;
  if (r.legacy || !rates) return { label: r.label, tone: r.tone };
  if (r.overriddenKeys.length) return { label: `예외 ${formatNumber(r.overriddenKeys.length)}칸`, tone: 'override' };
  return { label: `기본 요율 ${rates.default_version || EMPTY}`, tone: 'default' };
});

// 정산 대상 아닌 달은 정산서가 없어도 '추정 중'이 아니라 회색 '정산 대상 아님'(detailStatusBadge)
const statusBadge = computed(() => detailStatusBadge(props.detail));
/** One short status word for the pill (the settle tab shows who/when) */
const statusLabel = computed(() => {
  const st = props.detail?.statement ?? null;
  const status = statusBadge.value.status;
  if (status === 'review' && st?.reopened) return '검토 필요(재수정)';
  if (status === 'confirmed' && st?.confirmed_by === 'system') return '자동 확정';
  return STATEMENT_STATUS_META[status]?.label ?? statusBadge.value.label;
});
const canReopen = computed(() => statementStatusOf(props.detail) === 'confirmed');

/** 정산 시작일 — 새 칸이 없는 응답이면 '시작일 미설정'(settlementScopeView 가 1-10 기본값으로 읽는다) */
const scope = computed(() => settlementScopeView(props.detail));
const startChipTooltip = computed(() =>
  props.canEditStart ? `${scope.value.chip.tooltip} 누르면 정산 시작일을 바꿉니다.` : scope.value.chip.tooltip
);

// ---------------------------------------------------------------------------
// 정산 요약 줄
// ---------------------------------------------------------------------------

const summary = computed(() => summaryLine(props.detail));
/** 정산 시작일 전 달 — 청구 금액 자리는 '청구 없음', 마진 '—' */
const notBillable = computed(() => summary.value.notBillable === true);
const notBillableText = computed(() => summary.value.supply.notBillableText || '청구 없음');
/** 시작 월(1일 아님) — vox 원가는 청구분, 시작 전 원가를 따로 */
const hasPreStart = computed(() => isNumber(summary.value.cost.preStart));
// 기본 요율 버전이 없는 달(DEFAULT_PLAN_MISSING) — rates·margin 이 null. charge 는 사람이 금액을 넣었을 때만 온다(회신 표 16)
const noPlan = computed(() => !props.detail?.rates || !props.detail?.charge);
/** 그 달 기본 버전이 v70 이전 모양이면 그 버전을 말한다(DEFAULT_PLAN_MISSING `legacy_version`) */
const noPlanText = computed(() => {
  const legacyVersion = legacyPlanVersionOf(props.detail?.warnings);
  return legacyVersion
    ? `그 달에 적용되는 기본 요율 ${legacyVersion} 버전이 요금표 v70 이전 모양이라 금액을 계산하지 않았습니다.`
    : '그 달에 적용할 기본 요율 버전이 없어 금액을 계산하지 않았습니다.';
});
/** v70 이전에 만든 정산서의 안내 두 줄 */
const legacyLines = computed(() => [LEGACY_STATEMENT_TEXT, legacyStatementActionText(statementStatusOf(props.detail))]);

const supplyTooltipLines = computed(() => {
  const s = summary.value;
  if (notBillable.value) return [scope.value.chip.tooltip];
  if (s.supply.legacy) return s.internal ? ['내부·테스트 회사는 청구가 0원입니다.'] : legacyLines.value;
  if (s.supply.manualOnly) {
    if (s.internal) return ['내부·테스트 회사는 청구가 0원입니다.'];
    return [MANUAL_ONLY_TEXT, s.supply.breakdown].filter(Boolean);
  }
  if (noPlan.value) return [noPlanText.value];
  if (s.internal) return ['내부·테스트 회사는 청구가 0원입니다.'];
  return ['서티 청구 · 부가세 별도 · 일회성 항목 포함', s.supply.breakdown].filter(Boolean);
});

const sourceWord = computed(() => SOURCE_WORDS[summary.value.supply.source] ?? '');
const hasPills = computed(() => {
  const sup = summary.value.supply;
  return sup.partial || sup.legacy || !!sup.lastConfirmed;
});

/** Margin rate — margin ÷ supply without one-off items (the base the margin is computed on), whole percent */
const marginRate = computed(() => {
  const s = summary.value;
  if (!isNumber(s.margin) || !isNumber(s.supply.amount)) return null;
  const base = s.supply.amount - oneOffAmountOf(props.detail);
  return base > 0 ? Math.round((s.margin * 100) / base) : null;
});

const lastConfirmedTooltip = computed(() => {
  const last = summary.value.supply.lastConfirmed;
  if (!last) return '';
  const who = actorLabel(last.confirmedBy, last.confirmedByName);
  return `재수정 중입니다. 다시 확정할 때까지 이 금액이 확정 정산 금액으로 남습니다(확정 ${formatKstDateTime(last.confirmedAt)} · ${who}).`;
});

/** '경고 n건' — tooltip lists them; a click opens the settle tab on its warning list */
const warningTooltipLines = computed(() => [...summary.value.warnings.tooltipLines, '누르면 정산 탭으로 갑니다.']);

function goWarnings() {
  emit('go-tab', 'settle', { type: 'focus-warnings' });
}

const vatTooltip = computed(() => {
  if (notBillable.value) return scope.value.chip.tooltip;
  return summary.value.vat === null ? noPlanText.value : `부가세 ${VAT_LABEL}`;
});

const totalTooltip = computed(() => {
  const s = summary.value;
  if (notBillable.value) return scope.value.chip.tooltip;
  if (s.totalWithVat === null) return noPlanText.value;
  const source = SOURCE_TOOLTIPS[s.supply.source] ?? '';
  return `공급가액 ${formatNumber(s.supply.amount)} + 부가세 ${formatNumber(s.vat)}${source ? ` · ${source}` : ''}`;
});

const costTooltipLines = computed(() => {
  const c = summary.value.cost;
  const lines = [`통화 ${formatWon(c.voxCall)} · 회선 ${formatWon(c.line)}`];
  if (hasPreStart.value) {
    lines.unshift(`정산 시작일부터의 청구분입니다(달 전체 ${formatWon(c.fullTotal)} − 시작 전 ${formatWon(c.preStart)}).`);
  } else if (notBillable.value) {
    lines.push('정산 대상 아닌 달이라 이 원가는 모두 우리 부담입니다.');
  }
  // 마감 전에는 회선 원가가 월정액 일할 추정이다(vox 청구서가 나오면 청구서 금액)
  if (arr(props.detail?.usage?.lines).some((line) => line?.source === 'estimate')) {
    lines.push('회선 원가는 월정액 일할 추정입니다.');
  }
  lines.push('부가세 별도');
  return lines;
});

/** '시작 전 원가' — 청구하지 않는 시작일 전 사용량의 vox 원가 */
const preStartTooltipLines = computed(() => {
  const c = summary.value.cost;
  return [
    '정산 시작일 전 사용량의 vox 원가입니다. 청구하지 않아 우리 부담이고 마진에서 빼지 않습니다.',
    `달 전체 vox 원가 ${formatWon(c.fullTotal)} = 청구분 ${formatWon(c.total)} + 시작 전 ${formatWon(c.preStart)}`,
  ];
});

const marginTooltipLines = computed(() => {
  const s = summary.value;
  if (notBillable.value) return ['정산 시작일 전 달이라 청구하지 않아 마진을 계산하지 않습니다.'];
  if (s.internal) return ['내부·테스트 회사는 마진을 계산하지 않습니다.'];
  if (s.supply.legacy) return ['요금표 v70 이전 정산서라 마진을 계산하지 않았습니다.', legacyLines.value[1]];
  if (s.supply.manualOnly) return [MANUAL_ONLY_TEXT];
  if (noPlan.value) return [noPlanText.value];
  const lines = [
    hasPreStart.value
      ? '서티 청구(일회성 항목 제외) − vox 원가(청구분) · 부가세 별도 · %는 그 청구 대비'
      : '서티 청구(일회성 항목 제외) − vox 원가 · 부가세 별도 · %는 그 청구 대비',
  ];
  if (s.marginInclPbxTrunk !== null) lines.push(`PBX 트렁크 추정 포함 시 마진 ${formatWon(s.marginInclPbxTrunk)}`);
  return lines;
});

// ---------------------------------------------------------------------------
// 목 — 마감 상태 고르기 · 사용량 바꾸기(개발용)
// ---------------------------------------------------------------------------

/** `목: 늦게 들어온 통화 n건` 이 더하는 통화 수 */
const MOCK_LATE_CALLS = 2;
// 사용량만 바꾸고 정산(마감 결과)은 건드리지 않는다 — 화면에 보이는 때가 마감 상태마다 다르다
const MOCK_USAGE_EFFECT_LINES = [
  '추정 중인 달은 바로 보이고, 검토 필요인 달은 정산 탭 [다시 계산] 뒤에 보입니다(상태는 검토 필요 그대로).',
  '확정된 달은 금액을 그대로 두고 STATEMENT_DRIFT(비차단)가 붙습니다.',
];
const MOCK_FINISH_TOOLTIP_LINES = [
  '그 달 미종료 통화를 모두 끝냅니다(목 사용량만 바꿉니다).',
  ...MOCK_USAGE_EFFECT_LINES,
];
const MOCK_LATE_TOOLTIP_LINES = [
  `1분짜리 AI 응대 ${MOCK_LATE_CALLS}통을 그 달 사용량에 더합니다(목 사용량만 바꿉니다).`,
  ...MOCK_USAGE_EFFECT_LINES,
  '마감한 달을 다시 계산하면 마감 때 읽은 vox 건수와 달라 COUNT_MISMATCH 가 붙습니다([vox 건수 확인] 뒤 다시 계산하면 풀립니다).',
];

const MOCK_CONFLICT_TOOLTIP =
  '다음 정산 쓰기(저장·다시 계산·확정·재수정·일회성 항목) 하나가 409 STATEMENT_CONFLICT 로 실패합니다 — 그 사이 자동 마감이나 다른 사람이 정산을 바꾼 경합 흉내. 한 번 쓰이면 꺼집니다.';

const MOCK_START_TOOLTIP =
  '이 병원의 정산 시작일을 규칙 검사 없이 바로 바꿉니다(정산서를 지우지 않음 — 시작 전 달에 남은 정산서 장면). 비우고 [적용]하면 지웁니다.';
const MOCK_WEB_SPLIT_TOOLTIP =
  '이 달 웹 사용량을 시작일로 나눌 일별 칸이 없는 것처럼 합니다 — 시작 월(1일 아님)이고 웹이 있으면 WEB_START_SPLIT_UNAVAILABLE. 대사 탭 [vox 건수 확인]으로 풀립니다.';

const MOCK_STOP_FAIL_TOOLTIP =
  '다음 재수정 하나가 503 PAYMENT_STOP_FAILED 로 실패합니다(정지 표식을 쓰지 못함) — 결제 요청 문서가 있는 수납 상태에서만 걸리고, 한 번 쓰이면 꺼집니다. 수납 상태 "결제 상태 읽기 실패"는 이 조작 없이도 늘 503 입니다.';

// 얼린 공유 상수라 a-select 에는 복사본을 넘긴다
const mockStatusOptions = settlementMockControls.STATUS_OPTIONS.map((option) => ({ ...option }));
const mockStatus = ref(null);
const mockConflict = ref(false);
// 수납 장면(상세의 수납 칸 넷·확정 고정·재수정 503 — 계약 묶음 9장)
const mockPaymentOptions = settlementMockControls.PAYMENT_OPTIONS.map((option) => ({ ...option }));
const mockPayment = ref(null);
const mockStopFail = ref(false);
// 정산 시작일 장면(규칙 검사 없이 바로 바꾼다 — 남은 정산서 장면을 만들 수 있다) · 다음 PUT 오류 · 웹 일별 칸 없음
const mockStartInput = ref('');
const mockStartFaultOptions = (settlementMockControls.START_FAULT_OPTIONS ?? []).map((option) => ({ ...option }));
const mockStartFault = ref(null);
const mockWebSplitMissing = ref(false);

// 상세를 다시 받을 때마다 목의 지금 상태로 맞춘다(재수정·확정 등 화면의 쓰기도 상태를 바꾸고, 충돌은 한 번 쓰이면 꺼진다)
watch(
  () => [props.mock, props.companyId, props.month, props.detail],
  () => {
    if (props.mock && props.companyId) {
      mockStatus.value = settlementMockControls.getStatus(props.companyId, props.month);
      mockConflict.value = settlementMockControls.getConflictNextWrite();
      mockPayment.value = settlementMockControls.getPaymentScenario(props.companyId, props.month);
      mockStopFail.value = settlementMockControls.getStopFailNextReopen();
      mockStartInput.value = settlementMockControls.getSettlementStartDate?.(props.companyId) ?? '';
      mockStartFault.value = settlementMockControls.getStartPutFault?.() ?? null;
      mockWebSplitMissing.value = !!settlementMockControls.getWebDaySplitMissing?.(props.companyId, props.month);
    }
  },
  { immediate: true }
);

function onMockConflict(checked) {
  if (!props.mock) return;
  settlementMockControls.setConflictNextWrite(checked);
  mockConflict.value = settlementMockControls.getConflictNextWrite();
}

function onMockStatus(value) {
  if (!props.mock || !value || value === mockStatus.value) return;
  settlementMockControls.setStatus(props.companyId, props.month, value);
  mockStatus.value = value;
  emit('mock-change');
}

/** 수납 장면을 고른다 — 상세를 다시 받아 수납 칸 넷이 바뀐다 */
function onMockPayment(value) {
  if (!props.mock || !value || value === mockPayment.value) return;
  settlementMockControls.setPaymentScenario(props.companyId, props.month, value);
  mockPayment.value = settlementMockControls.getPaymentScenario(props.companyId, props.month);
  emit('mock-change');
}

function onMockStopFail(checked) {
  if (!props.mock) return;
  settlementMockControls.setStopFailNextReopen(checked);
  mockStopFail.value = settlementMockControls.getStopFailNextReopen();
}

/** 시작일을 바로 넣는다(목 — 정산서를 지우지 않는다). 형식이 틀리면 알리기만 */
function onMockStartApply() {
  if (!props.mock) return;
  const value = mockStartInput.value.trim();
  if (!value) {
    onMockStartClear();
    return;
  }
  if (!settlementMockControls.setSettlementStartDate(props.companyId, value)) {
    message.warning('YYYY-MM-DD 형식의 실제 날짜를 넣으세요(목 시작일).');
    return;
  }
  emit('mock-change');
}

function onMockStartClear() {
  if (!props.mock) return;
  settlementMockControls.setSettlementStartDate(props.companyId, null);
  mockStartInput.value = '';
  emit('mock-change');
}

/** 다음 시작일 PUT 하나의 오류 — 상세는 그대로라 다시 받지 않는다 */
function onMockStartFault(value) {
  if (!props.mock || !value) return;
  settlementMockControls.setStartPutFault(value);
  mockStartFault.value = settlementMockControls.getStartPutFault();
}

function onMockWebSplitMissing(checked) {
  if (!props.mock) return;
  settlementMockControls.setWebDaySplitMissing(props.companyId, props.month, checked);
  mockWebSplitMissing.value = !!settlementMockControls.getWebDaySplitMissing(props.companyId, props.month);
  emit('mock-change');
}

/** 미종료 통화가 끝났다 — NOT_FINAL_CALLS 가 풀리는 흐름(2-4) */
function onMockFinishOpenCalls() {
  if (!props.mock) return;
  if (!settlementMockControls.finishOpenCalls(props.companyId, props.month)) {
    message.info('이 달에는 끝낼 미종료 통화가 없습니다(목 사용량은 그대로입니다).');
    return;
  }
  emit('mock-change');
}

/** 마감 뒤 늦게 들어온 통화 — 확정 달의 STATEMENT_DRIFT 흐름(2-4) */
function onMockAddLateCalls() {
  if (!props.mock) return;
  if (!settlementMockControls.addLateCalls(props.companyId, props.month, MOCK_LATE_CALLS)) {
    message.info('이 달은 목 사용량이 없어 통화를 더하지 않았습니다.');
    return;
  }
  emit('mock-change');
}
</script>

<style scoped lang="scss">
@use '../styles/settlement' as *;

// Status pill colours (mockup) — review orange · confirmed green · closing blue · failed red · estimating gray
@mixin status-tone($color, $bg) {
  background: $bg;
  color: $color;
}

.detail-head {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 20px;

  &__nav {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px 14px;
    font-size: 13px;
  }

  &__crumbs {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    color: $st-muted;
  }

  &__crumb-link {
    color: $st-text-secondary;
    text-decoration: none;

    &:hover {
      color: $st-accent;
      text-decoration: underline;
    }
  }

  &__crumb-current {
    color: $st-text;
    font-weight: 600;
  }

  &__back {
    color: $st-accent;
    font-weight: 600;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  // Dev-only mock controls, collapsed in one place
  &__dev {
    margin-left: auto;
    font-size: 12px;
  }

  &__dev-summary {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: $st-warning;
    cursor: pointer;
  }

  &__dev-body {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px 10px;
    max-width: 720px;
    margin-top: 6px;
    padding: 6px 10px;
    border: 1px dashed $st-warning-border;
    border-radius: 8px;
    background: #fffdf8;
    color: $st-text-secondary;
  }

  &__dev-field {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin: 0;
  }

  &__mock-select {
    width: 150px;
  }

  &__mock-date {
    width: 112px;
  }

  // Month picker + [엑셀 내보내기] on the right of the top row
  &__tools {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }

  &__export {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  &__top {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px 16px;
  }

  &__ident {
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-width: 0;
  }

  &__name-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 12px;
  }

  &__name {
    margin: 0;
    color: #000;
    font-size: 1.6rem;
    font-weight: 700;
    word-break: keep-all;
  }

  &__name-skeleton {
    vertical-align: middle;
  }

  &__sr {
    @include st-sr-only;
  }

  &__status {
    display: inline-flex;
    align-items: center;
    padding: 3px 12px;
    border-radius: 999px;
    font-size: 13.5px;
    font-weight: 600;
    white-space: nowrap;
    cursor: help;
    @include status-tone($st-text-secondary, #eef1f5);

    &.is-review {
      @include status-tone(#8a4500, #ffebd2);
    }

    &.is-confirmed {
      @include status-tone($st-ok, $st-ok-bg);
    }

    &.is-closing {
      @include status-tone($st-accent, $st-accent-bg);
    }

    &.is-failed {
      @include status-tone($st-danger, $st-danger-bg);
    }
  }

  // '경고 n건' — small link pill next to the status pill (outside the settle tab)
  &__warn {
    @include st-pill;
    height: auto; // override the global button { height: 40px }
    padding: 1px 10px;
    font-family: inherit;
    font-size: 12.5px;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }

    &:focus-visible {
      outline: 2px solid $st-accent;
      outline-offset: 1px;
    }

    &.is-danger {
      @include st-pill-tone($st-danger, $st-danger-bg, $st-danger-border);
    }

    &.is-muted {
      @include st-pill-tone($st-text-secondary, $st-bg, $st-border-strong);
    }

    &.is-ok {
      @include st-pill-tone($st-ok, $st-ok-bg, $st-ok-border);
    }
  }

  &__reopen {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  &__refreshing {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: $st-muted;
  }

  &__chips {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
  }

  &__chips-skeleton {
    width: 280px;
  }

  &__skeleton {
    max-width: 960px;
  }
}

// Gray chips — 구분 · 요율 · 상담사 연결
.head-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 999px;
  background: #eef1f5;
  color: #3b4450;
  font-size: 12.5px;
  white-space: nowrap;
  cursor: help;

  &__sub {
    color: $st-muted;
    font-size: 11.5px;

    &.is-warn {
      color: $st-warning;
      font-weight: 600;
    }
  }

  &.is-override {
    background: $st-override-bg;
    color: $st-override;
  }

  &.is-danger {
    background: $st-danger-bg;
    color: $st-danger;
  }

  &.is-warn {
    background: $st-warning-bg;
    color: $st-warning;
    font-weight: 600;
  }

  // Settlement start chip — a button when the start date can be edited
  &--start {
    border: 1px solid transparent;
    font-family: inherit;
    line-height: inherit;

    &.is-start_month {
      background: $st-accent-bg;
      color: $st-accent;
    }

    &.is-before_start {
      border-color: $st-border-strong;
    }
  }

  &.is-button {
    height: auto; // override the global button { height: 40px }
    cursor: pointer;

    &:hover {
      border-color: $st-accent-border;
    }

    &:focus-visible {
      outline: 2px solid $st-accent;
      outline-offset: 1px;
    }
  }
}

// Summary card — big total + four figures
.sum-card {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px 32px;
  padding: 18px 24px;
  border: 1px solid $st-border-strong;
  border-radius: 12px;
  background: #fff;

  &__main {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding-right: 32px;
    border-right: 1px solid $st-border;
  }

  &__label {
    font-size: 13px;
    color: $st-text-secondary;
  }

  &__dim {
    color: $st-muted;
  }

  &__big {
    @include st-num;
    font-size: 30px;
    font-weight: 700;
    letter-spacing: -0.5px;
    color: $st-text;
    cursor: help;

    &:focus-visible {
      outline: 2px solid $st-accent-border;
      outline-offset: 2px;
      border-radius: 4px;
    }

    small {
      margin-left: 2px;
      font-size: 17px;
      font-weight: 600;
    }
  }

  &__pills {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
  }

  &__pill {
    @include st-pill;
    cursor: help;

    &.is-warn {
      @include st-pill-tone($st-warning, $st-warning-bg, $st-warning-border);
    }
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(100px, auto));
    gap: 4px 32px;
    margin: 0;

    // 시작 월 — '시작 전 원가' 칸이 하나 더
    &.has-pre-start {
      grid-template-columns: repeat(5, minmax(100px, auto));
    }
  }

  &__cell {
    display: flex;
    flex-direction: column;
    gap: 2px;

    dt {
      font-size: 12.5px;
      font-weight: 400;
      color: $st-text-secondary;
    }

    dd {
      @include st-num;
      margin: 0;
      font-size: 17px;
      font-weight: 600;
      color: $st-text;
      cursor: help;

      &:focus-visible {
        outline: 2px solid $st-accent-border;
        outline-offset: 2px;
        border-radius: 4px;
      }

      &.is-ok {
        color: $st-ok;
      }

      &.is-negative {
        color: $st-danger;
      }
    }
  }

  &__rate {
    margin-left: 2px;
    font-size: 13px;
    font-weight: 500;
  }
}

// Narrow screens — the total on its own row, figures two by two
@media (max-width: 640px) {
  .sum-card {
    padding: 16px;

    &__main {
      padding-right: 0;
      border-right: 0;
    }

    &__grid,
    &__grid.has-pre-start {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 10px 20px;
    }
  }
}
</style>
